// @flow
//Brand Colours
const black = 'rgb(0, 0, 0)'; //#000000
const brandActive = 'rgb(255, 122, 0)'; //#FF7A00
const brandBlock = 'rgb(41, 66, 76)'; //#29424C
const grey = 'rgb(47, 68, 78)'; //#2F444E
const paleGrey = 'rgb(251, 251, 251)'; //#FBFBFB
const secondaryBase = 'rgb(104, 129, 137)'; //#688189
const secondaryHeavy = 'rgb(165, 171, 175)'; //#A5ABAF
const secondaryLight = 'rgb(247, 248, 249)'; //#F7F8F9
const secondaryMedium = 'rgb(209, 212, 211)'; //#D1D4D3
const white = 'rgb(255, 255, 255)'; //#FFFFFF

const coolBlue = 'rgb(0, 165, 165)'; //#00A5A5
const coldBlue = 'rgb(69, 180, 255)'; //#45B4FF
const fontColor = brandBlock;
const footerLinkColor = 'rgb(122, 129, 134)'; //#7A8186
const greyBlue = 'rgb(42, 66, 75)'; //#2A424B
const turqoise = 'rgb(61, 232, 170)'; //#3DE8AA
const linkColor = 'rgb(37, 122, 124)'; //#257A7C
const secondaryLinkColor = 'rgb(37, 122, 124)'; //#257A7C
const vermillion = 'rgb(231, 45, 65)'; //#E72D41

const primaryBtnColor = brandActive;
const primaryBtnColorBusy = 'rgb(255, 155, 64)'; //#FF9B40
const primaryBtnColorDisabled = 'rgb(251, 226, 205)'; //#FBE2CD
const primaryBtnColorHover = 'rgb(255, 109, 0)'; //#FF6D00
const primaryBtnColorError = 'rgb(227, 77, 51)'; //#E34D33

const productBorderColor = 'rgb(241, 241, 241)'; // #f1f1f1
const frenchGrey = 'rgb(200, 199, 204)'; //#C8C7CC
const iron = 'rgb(204, 210, 214)'; //#CCD2D6
const pickledBluewood = 'rgb(51, 73, 91)'; //#33495B
const shuttleGrey = 'rgb(92, 109, 124)'; //#5C6D7C

const productStateBorderOn = `1px solid ${secondaryMedium}`;

// alert bar colours
const infoColor = 'rgb(61, 97, 232)'; //#3d61e8
const successColor = 'rgb(162, 198, 23)'; //#A2C617
const warningColor = 'rgb(72, 171, 159)'; //#48AB9F

export default {
    //primary colours
    mainBrandColor: brandActive,
    secondaryColor: brandBlock,
    white,
    black,
    secondaryHeavy,
    secondaryMedium,
    secondaryLight,
    dashboardOfflineColor: secondaryBase,
    footerColor: brandBlock,
    footerBackground: brandBlock,
    footerLink: footerLinkColor,
    primaryFontColor: grey,
    linkColor,
    cooling: coolBlue,
    coldTempBlue: coldBlue,
    turqoise,
    heating: brandActive,
    productBorderColor,
    frenchGrey,
    iron,
    pickledBluewood,
    shuttleGrey,
    secondaryLinkColor,
    fontColor,
    error: vermillion,
    infoColor,
    successColor,
    warningColor,
    // greys
    grey,
    secondaryBase,
    heavyGrey: secondaryHeavy,
    mediumGrey: secondaryMedium,
    lightGrey: secondaryLight,
    paleGrey,
    offlineGrey: secondaryMedium,
    fadedGrey: secondaryLight,
    blueyGrey: greyBlue,
    // borders
    flipperBorder: productStateBorderOn, // not sure this variable should be there
    // button colours
    primaryBtnColors: {
        default: primaryBtnColor,
        busy: primaryBtnColorBusy,
        disabled: primaryBtnColorDisabled,
        hover: primaryBtnColorHover,
        error: primaryBtnColorError
    },
    // measurments
    headerHeightRem: 4,
    headerHeightDesktopRem: 6,
    infoBarHeight: '3em',
    menuSubItemsContainer: '1px',
    mobileMenuWidth: '16rem',
    // layout
    viewportMinWidth: '22.85714em' /* 320px width of an iPhone 4/5 */ /*calc(320px / var(--mobile-font-size));*/,
    layoutMaxWidth: '60rem',
    // font sizes
    mobileFontSize: '14px',
    tabletFontSize: '16px',
    desktopFontSize: '18px'
};



// WEBPACK FOOTER //
// ./src/core/themes/main/deprecated-styles.js